export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`
  }
  return text
}

export const randomShippingFee = (min, max) => {
  const minValue = min
  const maxValue = max
  const randomValue =
    Math.floor(Math.random() * (maxValue / 100 - minValue / 100 + 1)) + minValue / 100
  const evenRandomValue = Math.floor(randomValue) * 100

  return evenRandomValue
}
